import { KnmSignatureInfoStatusesEnum } from '../APIPackage/KnmModule/enums/KnmSignatureInfoStatusesEnum';
import { IKnmSignatureInfo } from '../APIPackage/KnmModule/interfaces/IKnmSignatureInfo';

export const getDisplayedSignatureInfo = (signatureInfo: IKnmSignatureInfo[] | null | undefined) => {
  const sortedSignaturesInfo =
    !!signatureInfo && signatureInfo.length > 0
      ? signatureInfo.sort((a, b) => {
          const dateA = new Date(a.signedDate).getTime();
          const dateB = new Date(b.signedDate).getTime();

          return dateB - dateA;
        })
      : [];

  return sortedSignaturesInfo?.find(item => item.status === KnmSignatureInfoStatusesEnum.VALID);
};
